export default __webpack_public_path__ + "static/rsz_michal_j-e4d140c1854fb918dec21e918ac176d1.jpg";